import React from "react";
import InfoData from "../InfoData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const contacts = InfoData.contacts;

const ContactItem = ({icon, url, text, file}) => {
    if (!url && file) {
        url = require(`../${file}`);
    }
    return (
        <a className="flex items-center gap-2 z-[5] group" href={url} target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={icon} className="text-4xl"/>
            <div className="bg-white h-[35px] text-base hidden items-center px-4 rounded-3xl group-hover:flex">{text}</div>
        </a>
    );
}

const ContactContainer = () => {
    return (
        <div className="absolute right-[5%] bottom-[10%] flex items-end flex-col gap-3">
            {contacts.map((contact, index) => (
                <ContactItem key={index} {...contact}/>
            ))}
        </div>
    );
}

export default ContactContainer;